export default __webpack_public_path__ + "static/ossec-1145c2f4103c6d29ae324d062dac29e8.png";